import { SVGIconComponent } from './types';

export const LockerMR: SVGIconComponent = ({ className, color, style }) => (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 25 26"
    xmlSpace="preserve"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Locker-Sizes_x2F_locker-MR">
      <g id="locker-M">
        <g id="M">
          <path
            id="path-1_00000068647222741339704350000003836205109934418065_"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
            d="M12.8,0l11.5,5.5c0.2,0.1,0.3,0.3,0.3,0.5
				l0,10.8c0,0.2-0.1,0.3-0.2,0.4l-11.6,8.4l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
				c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0
				c0,0,0,0,0,0l-12-6.9C0.1,18.7,0,18.5,0,18.3V7.9c0-0.3,0.2-0.5,0.4-0.5l11.9-7.3C12.5,0,12.7,0,12.8,0z M1,8.8V18l11,6.3v-9.4
				L1,8.8z M23.6,7.2L13,14.8v9.4l10.6-7.6V7.2z M12.6,1.1L1.5,7.9L12.4,14l10.7-7.8L12.6,1.1z"
          />
        </g>
      </g>
      <g id="Shape" transform="translate(12.500000, 6.500020)">
        <g id="Mask"></g>
        <mask
          maskUnits="userSpaceOnUse"
          x="-5"
          y="-0.5"
          width="14"
          height="16"
          id="mask-4_00000003815724372346063660000014890101312887392923_"
        >
          <g>
            <polygon
              id="path-3_00000006696061843020593850000015412754964739111333_"
              fillRule="evenodd"
              clipRule="evenodd"
              fill="currentColor"
              points="0,8.5 11,0 11,20.5 0,20.5 				
					"
            />
          </g>
        </mask>
        <path
          mask="url(#mask-4_00000003815724372346063660000014890101312887392923_)"
          fill="currentColor"
          d="M8.7,10.7l-1.1-0.6l0.9-0.4c0.3-0.1,0.4-0.5,0.2-0.8C8.7,8.6,8.3,8.5,8.1,8.6L6.5,9.4L4.2,8.1
			c0.1-0.4,0.1-0.8,0-1.2l2.3-1.3l1.6,0.8c0.3,0.1,0.6,0,0.7-0.3c0.1-0.3,0-0.6-0.2-0.8L7.7,4.9l1.1-0.6C9,4.1,9.1,3.8,8.9,3.5
			C8.8,3.2,8.4,3.2,8.2,3.3L7.1,3.9l0.1-1c0-0.3-0.2-0.6-0.5-0.6C6.3,2.3,6,2.5,6,2.9L5.9,4.6L3.6,5.9C3.3,5.6,3,5.4,2.6,5.3V2.7
			l1.5-1c0.1-0.1,0.2-0.2,0.3-0.4c0-0.2,0-0.3-0.1-0.4C4.1,0.8,4,0.7,3.9,0.6c-0.2,0-0.3,0-0.4,0.1L2.6,1.3V0.1
			c0-0.3-0.3-0.6-0.6-0.6S1.4-0.2,1.4,0.1v1.2L0.6,0.7C0.5,0.6,0.3,0.6,0.2,0.6C0,0.6-0.1,0.7-0.2,0.9C-0.3,1-0.3,1.1-0.3,1.3
			c0,0.2,0.1,0.3,0.3,0.4l1.5,1v2.6C1,5.4,0.7,5.6,0.4,5.9l-2.3-1.3L-2,2.8c0-0.3-0.3-0.6-0.6-0.5s-0.6,0.3-0.5,0.6l0.1,1l-1.1-0.6
			c-0.3-0.1-0.6,0-0.8,0.2C-5,3.8-5,4.1-4.7,4.3l1.1,0.6l-0.9,0.4c-0.3,0.1-0.4,0.5-0.3,0.8C-4.6,6.4-4.3,6.5-4,6.4l1.6-0.8l2.3,1.3
			c-0.1,0.4-0.1,0.8,0,1.2l-2.3,1.3L-4,8.6c-0.1-0.1-0.3-0.1-0.4,0c-0.1,0-0.3,0.2-0.3,0.3c-0.1,0.1-0.1,0.3,0,0.4
			c0.1,0.1,0.2,0.3,0.3,0.3l0.9,0.4l-1.1,0.6c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.3
			c0.2,0,0.3,0,0.4-0.1l1.1-0.6l-0.1,1c0,0.3,0.2,0.6,0.5,0.6h0c0.3,0,0.6-0.2,0.6-0.5l0.1-1.7l2.3-1.3c0.3,0.3,0.6,0.5,1,0.6v2.6
			l-1.5,1c-0.2,0.2-0.3,0.5-0.1,0.8s0.5,0.3,0.8,0.2l0.8-0.6v1.2c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6v-1.2l0.8,0.6
			c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2-0.1-0.3-0.3-0.4l-1.5-1V9.7C3,9.6,3.4,9.4,3.6,9.1
			l2.3,1.3L6,12.2c0,0.3,0.3,0.5,0.6,0.5h0c0.3,0,0.5-0.3,0.5-0.6l-0.1-1l1.1,0.6c0.3,0.1,0.6,0,0.8-0.2C9.1,11.2,9,10.9,8.7,10.7
			L8.7,10.7z M2,8.6C1.6,8.6,1.1,8.4,1,7.9C0.8,7.5,0.9,7,1.2,6.7C1.5,6.4,2,6.3,2.5,6.4C2.9,6.6,3.2,7,3.2,7.5
			c0,0.3-0.1,0.6-0.3,0.8S2.3,8.6,2,8.6L2,8.6z"
        />
      </g>
    </g>
  </svg>
);
